import { C as CosmosIconCloseSmall$1, d as defineCustomElement$1 } from './p-Wm3pAWRJ.js';

const CosmosIconCloseSmall = CosmosIconCloseSmall$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCloseSmall, defineCustomElement };
